import { useEffect, useState } from 'react';
import { validateIfUserIsOnline } from '../utils/network';

export enum UserOnlineStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  LOADING = 'LOADING',
}

/** @description
 * hook criado para validar se no momento que chamamos o hook o user está online, o hook não é reativo, ou seja, ele não fica monitorando a conexão do user
 */
const useUserOnlineStatus = () => {
  const [userOnlineStatus, setUserOnlineStatus] = useState<UserOnlineStatus>(
    UserOnlineStatus.LOADING,
  );

  const updateIsOnlineState = async () => {
    const userIsOnline = await validateIfUserIsOnline();

    if (userIsOnline) {
      setUserOnlineStatus(UserOnlineStatus.ONLINE);
    } else {
      setUserOnlineStatus(UserOnlineStatus.OFFLINE);
    }
  };

  useEffect(() => {
    updateIsOnlineState();
  }, []);

  return {
    userOnlineStatus,
    updateIsOnlineState,
    isOnline: userOnlineStatus === UserOnlineStatus.ONLINE,
    isLoadingOnlineStatus: userOnlineStatus === UserOnlineStatus.LOADING,
  };
};

export default useUserOnlineStatus;
